import React from 'react';
import { BarcodeBlock } from './basic-blocks/barcode';
import { isBarcodeBlock } from './basic-blocks/barcode/utils';
import { CaptionBlock } from './basic-blocks/caption';
import { isCaptionBlock } from './basic-blocks/caption/utils';
import { ImageBlock } from './basic-blocks/image';
import { isImageBlock } from './basic-blocks/image/utils';
import { QrcodeBlock } from './basic-blocks/qrcode';
import { isQrcodeBlock } from './basic-blocks/qrcode/utils';
import { SignatureBlock } from './basic-blocks/signature';
import { isSignatureBlock } from './basic-blocks/signature/utils';
import { ValueBlock } from './basic-blocks/value';
import { isValueBlock } from './basic-blocks/value/utils';
import { isBillContentBlock } from './content-blocks/billing/utils';
import { BillContentBlock } from './content-blocks/billing';
import { BlockProps } from './content-blocks/type';
import {
  isContraVoucherContentBlock,
  isIssueKarigarBillContentBlock,
  isIssuePartyBillContentBlock,
  isIssueRefineBillContentBlock,
  isJournalVoucherContentBlock,
  isKarigarReceiveBillContentBlock,
  isMetalToCashContentBlock,
  isMetalToCashReceiptContentBlock,
  isOpeningContentBlock,
  isPaymentVoucherContentBlock,
  isPurchaseBillContentBlock,
  isPurchaseReturnBillContentBlock,
  isReceiptVoucherContentBlock,
  isReceivePartyBillContentBlock,
  isReceiveRefineBillContentBlock,
  isSalesBillContentBlock,
  isSalesOrderContentBlock,
  isSalesSalesReturnContentBlock,
} from './content-blocks/account/utils';
import { AccountBillContentBlock } from './content-blocks/account';
import { isLineBlock } from './basic-blocks/line/utils';
import { LineBlock } from './basic-blocks/line';
import { isUploadImageBlock } from './basic-blocks/upload-image/utils';
import { ImageUploadBlock } from './basic-blocks/upload-image';
import { isRectangleBlock } from './basic-blocks/rectangle/utils';
import { RectangleBlock } from './basic-blocks/rectangle';
import { isInstaBlock } from './basic-blocks/insta-icon/utils';
import { InstaBlock } from './basic-blocks/insta-icon';
import { FacebookBlock } from './basic-blocks/facebook';
import { isFacebookBlock } from './basic-blocks/facebook/utils';
import { isGmailBlock } from './basic-blocks/gmail/utils';
import { TiktokBlock } from './basic-blocks/tiktok';
import { isTiktokBlock } from './basic-blocks/tiktok/utils';
import { GMailBlock } from './basic-blocks/gmail';
import { WebsiteBlock } from './basic-blocks/website';
import { isWebsiteBlock } from './basic-blocks/website/utils';
import { ImageContainerBlock } from './basic-blocks/image-container';
import { isImageContainerBlock } from './basic-blocks/image-container/utils';

interface BlockRenderProps {
  block: BlockProps;
  maxWidth: number;
  scaleFactor?: number;
  isEditorMode?: boolean;
}

const BlockRender: React.FC<BlockRenderProps> = (props) => {
  const { block, maxWidth, scaleFactor = 1, isEditorMode = false } = props;

  return (
    <>
      {isBarcodeBlock(block) ? (
        <BarcodeBlock blockProps={block} scaleFactor={scaleFactor} />
      ) : isQrcodeBlock(block) ? (
        <QrcodeBlock blockProps={block} scaleFactor={scaleFactor} />
      ) : isValueBlock(block) ? (
        <ValueBlock blockProps={block} scaleFactor={scaleFactor} />
      ) : isCaptionBlock(block) ? (
        <CaptionBlock
          blockProps={block}
          scaleFactor={scaleFactor}
          maxWidth={maxWidth}
        />
      ) : isSignatureBlock(block) ? (
        <SignatureBlock blockProps={block} scaleFactor={scaleFactor} />
      ) : isImageBlock(block) ? (
        <ImageBlock blockProps={block} scaleFactor={scaleFactor} />
      ) : isUploadImageBlock(block) ? (
        <ImageUploadBlock blockProps={block} scaleFactor={scaleFactor} />
      ) : isPurchaseBillContentBlock(block) ||
        isSalesBillContentBlock(block) ||
        isSalesSalesReturnContentBlock(block) ||
        isKarigarReceiveBillContentBlock(block) ||
        isPurchaseReturnBillContentBlock(block) ||
        isReceivePartyBillContentBlock(block) ||
        isReceiveRefineBillContentBlock(block) ||
        isJournalVoucherContentBlock(block) ||
        isContraVoucherContentBlock(block) ||
        isReceiptVoucherContentBlock(block) ||
        isPaymentVoucherContentBlock(block) ||
        isMetalToCashReceiptContentBlock(block) ||
        isMetalToCashContentBlock(block) ||
        isOpeningContentBlock(block) ||
        isSalesOrderContentBlock(block) ||
        isIssueKarigarBillContentBlock(block) ||
        isIssueRefineBillContentBlock(block) ||
        isIssuePartyBillContentBlock(block) ? (
        <AccountBillContentBlock
          blockProps={block}
          scaleFactor={scaleFactor}
          maxWidth={maxWidth}
        />
      ) : isBillContentBlock(block) ? (
        <BillContentBlock
          blockProps={block}
          scaleFactor={scaleFactor}
          maxWidth={maxWidth}
        />
      ) : isLineBlock(block) ? (
        <LineBlock
          blockProps={block}
          scaleFactor={scaleFactor}
          maxWidth={maxWidth}
        />
      ) : isInstaBlock(block) ? (
        <InstaBlock
          blockProps={block}
          scaleFactor={scaleFactor}
          maxWidth={maxWidth}
        />
      ) : isTiktokBlock(block) ? (
        <TiktokBlock
          blockProps={block}
          scaleFactor={scaleFactor}
          maxWidth={maxWidth}
        />
      ) : isGmailBlock(block) ? (
        <GMailBlock
          blockProps={block}
          scaleFactor={scaleFactor}
          maxWidth={maxWidth}
        />
      ) : isFacebookBlock(block) ? (
        <FacebookBlock
          blockProps={block}
          scaleFactor={scaleFactor}
          maxWidth={maxWidth}
        />
      ) : isWebsiteBlock(block) ? (
        <WebsiteBlock
          blockProps={block}
          scaleFactor={scaleFactor}
          maxWidth={maxWidth}
        />
      ) : isRectangleBlock(block) ? (
        <RectangleBlock
          blockProps={block}
          scaleFactor={scaleFactor}
          maxWidth={maxWidth}
        />
      ) : isImageContainerBlock(block) ? (
        <ImageContainerBlock
          blockProps={block}
          scaleFactor={scaleFactor}
          isEditorMode={isEditorMode}
        />
      ) : (
        <>Block Not Implemented</>
      )}
    </>
  );
};

export default BlockRender;
